import { render } from "./Date.vue?vue&type=template&id=64e0dab8&scoped=true"
import script from "./Date.vue?vue&type=script&lang=js"
export * from "./Date.vue?vue&type=script&lang=js"

import "./Date.vue?vue&type=style&index=0&id=64e0dab8&lang=scss"
import "./Date.vue?vue&type=style&index=1&id=64e0dab8&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e0dab8"]])

export default __exports__